import React from 'react';

const DeploymentPipelineDeleted = (props) => {
  return <span>Deployment Pipeline deleted by {props.userEmail}</span>;
};

export default DeploymentPipelineDeleted;
